const charReducerDefaultState = {
    char: undefined,
    charInc: 0,
    charCase: 'lc',
    charClearState: false
};

export default (state = charReducerDefaultState, action) => {
    switch (action.type) {
        case 'CHAR_SELECTED':
            return {
                ...state,
                char: action.char
            };
        case 'CHAR_INC':
            return {
                ...state,
                char: action.charInc + 1
            };
        case 'CHAR_CASE':
            return {
                ...state,
                charCase: action.charCase
            };
        case 'CHAR_CLEAR':
            return {
                ...state,
                charClearState: action.charClearState
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/char.js